'use client';

import Step1 from './steps/Step1/index';
import Step2 from './steps/Step2/index';
import Step3 from './steps/Step3/index';
import styles from './index.module.less';

interface ImageConfirmationProps {
  imageUrl: string;
  isLoading?: boolean;
  currentStep: number;
  searchMode: 'low' | 'high';
}

export default function ImageConfirmation({
  imageUrl,
  isLoading = true,
  currentStep,
  searchMode,
}: ImageConfirmationProps) {
  return (
    <div className={styles.container}>
      {/* 根据不同的搜索模式，显示不同的步骤 */}
      {searchMode === 'low' && (
        <>
          {currentStep <= 1 && <Step1 imageUrl={imageUrl} isLoading={isLoading} />}
          {currentStep >= 2 && <Step3 />}
        </>
      )}

      {searchMode === 'high' && (
        <>
          {currentStep === 0 && <Step1 imageUrl={imageUrl} isLoading={isLoading} />}
          {(currentStep === 1 || currentStep === 2) && <Step2 />}
          {currentStep >= 3 && <Step3 />}
        </>
      )}

      {/* 四角装饰线 - 移到外层容器 */}
      <div className={styles.cornerDecoration}>
        {/* 左上角 */}
        <div className={`${styles.cornerLine} ${styles.topLeftHorizontal}`} />
        <div className={`${styles.cornerLine} ${styles.topLeftVertical}`} />

        {/* 右上角 */}
        <div className={`${styles.cornerLine} ${styles.topRightHorizontal}`} />
        <div className={`${styles.cornerLine} ${styles.topRightVertical}`} />

        {/* 左下角 */}
        <div className={`${styles.cornerLine} ${styles.bottomLeftHorizontal}`} />
        <div className={`${styles.cornerLine} ${styles.bottomLeftVertical}`} />

        {/* 右下角 */}
        <div className={`${styles.cornerLine} ${styles.bottomRightHorizontal}`} />
        <div className={`${styles.cornerLine} ${styles.bottomRightVertical}`} />
      </div>
    </div>
  );
}
